<div class="flex flex-col h-full gap-4">
  @if (isStream) {
    <input
      pInputText
      [(ngModel)]="streamName"
      placeholder="Stream name"
      class="w-full"
      [autofocus]="true"
      data-e2e="new-stream-name"
    />
  }
  <p-autoComplete
    [(ngModel)]="selectedUsers"
    [suggestions]="suggestions"
    (completeMethod)="search($event)"
    optionLabel="displayName"
    placeholder="Search by name or email"
    [minLength]="2"
    [multiple]="true"
    styleClass="w-full"
    [inputStyle]="{ width: '100%' }"
    [dropdown]="false"
    [autofocus]="!isStream"
    appendTo="body"
    data-e2e="new-conversation-user-search"
  />
  <div class="flex justify-end gap-2 mt-auto">
    <p-button label="Cancel" [text]="true" (onClick)="ref.close()" />
    <p-button
      [label]="isStream ? 'Create Stream' : 'Start Chat'"
      [disabled]="!canStart || creating"
      [loading]="creating"
      (onClick)="start()"
      data-e2e="new-conversation-start"
    />
  </div>
</div>
